import React, { useEffect, useRef, useState } from 'react';
import rtc, { initAgora, leaveAgora } from './AgoraUtility';
import { Modal } from '@mui/material';

function ChatVideoCall({ channelName, token, uid, role = "host", open, onClose }) {
  const localRef = useRef(null);
  const remoteRef = useRef(null);
  const [joined, setJoined] = useState(false);

  useEffect(() => {
    const setup = async () => {
      await initAgora(channelName, token, uid, "rtc", role);

      // Show local video
      if (localRef.current && rtc.localVideoTrack) {
        rtc.localVideoTrack.play(localRef.current);
      }

      rtc.client.on("user-published", async (user, mediaType) => {
        await rtc.client.subscribe(user, mediaType);
        if (mediaType === "video") {
          remoteRef.current.innerHTML = ""; // Clear previous content
          user.videoTrack.play(remoteRef.current);
        }
        if (mediaType === "audio") {
          user.audioTrack.play();
        }
      });

      rtc.client.on("user-unpublished", () => {
        remoteRef.current.innerHTML = "";
      });

      setJoined(true);
    };

    setup();

    return () => {
      leaveAgora();
      setJoined(false);
    };
  }, []);

  return (
    <Modal
    open={open}
    onClose={onClose}
    >
        <div className="w-full h-screen flex flex-col md:flex-row bg-gray-900">
      <div ref={localRef} className="w-full md:w-1/2 h-1/2 md:h-full bg-black"></div>
      <div ref={remoteRef} className="w-full md:w-1/2 h-1/2 md:h-full bg-gray-800"></div>
    </div>
    </Modal>
    
  );
}

export default ChatVideoCall;
